module.exports = __webpack_public_path__ + "img/icon-heart.024de91d.png";